import BigNumber from 'bignumber.js';
import { differenceInMinutes } from 'date-fns';
import { GrfqQuote } from '#/unified-rfqs/entities/grfq/domain';
import { TradeMatchData } from './types';

const RECENT_TRADE_MINUTES = 5;
export function isRecentTrade(tradeTime: number | Date) {
  return differenceInMinutes(Date.now(), tradeTime) <= RECENT_TRADE_MINUTES;
}

export function isBetterPrice(trade: TradeMatchData, quote: GrfqQuote) {
  const tradedPrice = BigNumber(trade.price);
  const quotedPrice = BigNumber(quote.price);
  return quote.side === 'SELL'
    ? quotedPrice.lte(tradedPrice)
    : quotedPrice.gte(tradedPrice);
}

export function isBetterMark(
  trade: TradeMatchData,
  quote: GrfqQuote,
  markPrice: string | null,
) {
  const tradeSpread = BigNumber(trade.price).minus(trade.markPrice);
  const quoteSpread = BigNumber(quote.price).minus(markPrice ?? '0');
  return quote.side === 'SELL'
    ? quoteSpread.lte(tradeSpread)
    : quoteSpread.gte(tradeSpread);
}
